// client/src/shared/components/PenaltyPopover/index.js
import React from 'react';
import PropTypes from 'prop-types';
import BadgePopover from '../BadgePopover';
import { penaltyDaysLate } from '../../utils/formatters';

const PenaltyPopover = ({ activity, popoverId, placement = 'top', currentUsername, children }) => {
    const body = (
        <>
            <p className="mb-1">Logged <strong>{penaltyDaysLate(activity.penaltyFactor)}</strong> after the activity date.</p>
            <p className="mb-1"><strong>{Math.round((1 - activity.penaltyFactor) * 100)}% reduction</strong> applied to points.</p>
            {activity.rawPoints !== undefined && (
                <p className="mb-1">{parseFloat(activity.rawPoints).toFixed(1)} raw pts × {activity.penaltyFactor} = <strong>{parseFloat(activity.points).toFixed(1)} pts</strong></p>
            )}
            <p className="mb-0 text-muted" style={{ fontSize: '0.8em' }}>20% reduction per day late (after 24 h), capped at 100%.{activity.username === currentUsername ? ' You can request an exemption on the activity page.' : ''}</p>
        </>
    );

    return (
        <BadgePopover
            popoverId={popoverId}
            header="Late-logging Penalty"
            body={body}
            placement={placement}
        >
            {children}
        </BadgePopover>
    );
};

PenaltyPopover.propTypes = {
    activity: PropTypes.shape({
        penaltyFactor: PropTypes.number.isRequired,
        rawPoints: PropTypes.number,
        points: PropTypes.number.isRequired,
        username: PropTypes.string,
    }).isRequired,
    popoverId: PropTypes.string.isRequired,
    placement: PropTypes.string,
    currentUsername: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default PenaltyPopover;
